import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const lark = defineConnector({
  identifier: "lark",
  name: "Lark",
  tagLine: "Collaboration and productivity suite",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://open\\.larksuite\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://open.feishu.cn/open-apis/auth/v3/tenant_access_token/internal",
        jsonBody: {
          app_id: app.config.appId,
          app_secret: app.secret.appSecret,
        },
      },
      extract: { from: "jsonPath", paths: ["tenant_access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create a Lark app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Lark Developer Console](https://open.larksuite.com/app) and create a new custom app. Note the **App ID** and **App Secret** from the app’s credentials page.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "App ID",
          required: true,
          target: { kind: "configuration", field: "appId" },
        },
        {
          kind: "input",
          label: "App secret",
          required: true,
          target: { kind: "secrets", field: "appSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://open.larksuite.com/open-apis/auth/v3/tenant_access_token/internal/",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    }),
  },
});
